var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.2 127.2",
    style: {
      enableBackground: "new 0 0 127.2 127.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#008F33;}\r\n\t.st1{opacity:0.5;fill:#008F33;}\r\n\t.st2{fill:#00B035;}\r\n\t.st3{fill:#00D074;}\r\n\t.st4{fill:#00561F;}\r\n\t.st5{fill:#002A00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.6,52.4v-4.9C40.6,33.9,49.9,18,62,18h3.2c12,0,21.4,15.9,21.4,29.5v4.9h12.9v-12c0-9-3.5-18.3-9.7-25.6 c-6.6-7.8-15.2-12-24.3-12h-3.7c-9,0-17.6,4.3-24.3,12c-6.2,7.2-9.7,16.5-9.7,25.6v12H40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.6,14.8c-0.6-0.7-1.1-1.3-1.7-1.9c0.3,0.7,0.5,1.5,0.6,2.3c0.1,2.1-0.8,4.3-2.4,5.6 c-1.5,1.2-3.4,1.2-5.1,0.5c-1.2-0.5-2.3-1.3-3.4-2c-1.3-0.8-2.6-1.5-4.1-2c-2.8-1.1-5.7-1.6-8.7-1.7C59.4,15.5,54,17,49.6,20.1 c-4.1,2.9-7.1,7-9.2,11.5c-1.5,3.1-2.1,6.7-4.4,9.4c-1,1.1-2.3,1.9-3.8,1.6c-1.7-0.4-2.9-1.4-3.5-3c-0.4-1-0.6-2-0.7-3 c-0.1,1.2-0.2,2.5-0.2,3.7v12h12.9v-4.9C40.6,33.9,49.9,18,62,18h3.2c12,0,21.4,15.9,21.4,29.5v4.9h12.9v-12 C99.3,31.4,95.8,22,89.6,14.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 48.1,
    className: "st1",
    width: 12.9,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7,
    y: 48.1,
    className: "st1",
    width: 12.9,
    height: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.2,53.9c-0.3-0.7-0.8-1.4-1.4-1.9c-0.9-0.7-1.9-1-3-1.2h-83c-1.1,0.2-2.2,0.5-3,1.3 c-0.7,0.6-1.1,1.4-1.2,2.3c0,0.1,0,0.3,0,0.5v17.8c0,68.1,91.8,69.8,91.8,0V54.8C109.4,54.5,109.3,54.2,109.2,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.3,54.9c-0.3-0.7-0.7-1.3-1.3-1.8c-0.9-0.6-1.8-0.9-2.8-1.1H23.5c-1.1,0.2-2.1,0.5-2.9,1.2 c-0.7,0.6-1.1,1.3-1.2,2.1c0,0.1,0,0.3,0,0.5v16.4c0,63,88.2,64.6,88.2,0V55.8C107.5,55.5,107.4,55.2,107.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.6,56.1c-0.3-0.6-0.7-1.1-1.2-1.5c-0.8-0.5-1.7-0.8-2.6-1H26.3c-1,0.1-1.9,0.4-2.6,1 c-0.6,0.5-1,1.1-1.1,1.8c0,0.1,0,0.3,0,0.4v14c0,53.7,81.2,55.1,81.2,0V56.8C103.7,56.5,103.7,56.3,103.6,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.4,73.9c0-5.6-4.8-10.2-10.8-10.2c-6,0-10.8,4.6-10.8,10.2c0,4.3,2.8,8,6.9,9.5l-7.8,23.4h22.6l-7.1-23.3 C71.4,82,74.4,78.3,74.4,73.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.7,73.9c0-5.2,4.1-9.5,9.3-10.1c-0.5-0.1-1-0.1-1.5-0.1c-6,0-10.8,4.6-10.8,10.2c0,4.3,2.8,8,6.9,9.5 l-7.8,23.4h2.9l7.8-23.4C58.5,81.9,55.7,78.2,55.7,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.4,73.9c0-5.2-4.1-9.5-9.4-10.1c-5.3,0.7-9.3,5-9.3,10.1c0,4.3,2.8,8,6.9,9.5l-7.8,23.4h19.6l-7.1-23.3 C71.4,82,74.4,78.3,74.4,73.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,35.6c0,0,5.5-32.6,39.4-31.4C68.7,4.2,38.6,6.4,29.3,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,57.5c0,0-1.1,2.7,0.2,5.1c1.2,2.4,14.9-1.2,14.6-4.4C39.9,55,27.5,52.5,25.4,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,69.1c0,0-0.5,2.4,0.1,4.6c0.6,2.1,7.4-1,7.3-3.9C32.3,66.8,26.1,64.7,25.1,69.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.28e9b193.svg";
export { ForwardRef as ReactComponent };